<rcl-header id="error-page-header" [bg]="brandName" [expandable]="false">
	<a id="error-page-header__link" href="" aria-haspopup="true" (click)="goToBrandUrl($event)">
		<img
			id="error-page-header__link-img"
			class="{{ brandName }}-header-logo"
			src="assets/icons/{{ brandName }}-logo.svg"
			alt="{{ brandCorpAltText }} Home"
		/>
	</a>

  @if (bundle) {
    <rcl-menu-button
      id="error-page-header__rcl-menu-button"
      [text]="(bundle | async)['user.menu.label.my.account']"
      [expanded]="showMenu"
      (onToggleNav)="showMenu = !showMenu">
    </rcl-menu-button>
  }

	<rcl-menu-button-dropdown id="error-page-header__rcl-menu-dropdown" *ngIf="!isSafari">
		<app-user-menu id="error-page-header__rcl-menu-dropdown__user-menu" [(showMenu)]="showMenu" [bundle]="bundle | async"></app-user-menu>
	</rcl-menu-button-dropdown>
</rcl-header>

<app-user-menu id="error-page__user-menu" [(showMenu)]="showMenu" *ngIf="isSafari" [bundle]="bundle | async"></app-user-menu>

<rcl-main-content id="error-page__main-content">
	<ng-container id="error-page__main-content-container">
		<rcl-system-error id="error-page__main-content-container__system-error">
      @if (bundle) {
        <rcl-system-error-title id="error-page__main-content-container__system-error-title">
          {{ (bundle | async)['error.technical.difficulties.header'] }}
        </rcl-system-error-title>
      }
			<rcl-system-error-description id="error-page__main-content-container__description">
        @if (bundle) {
          <img
            id="error-page__main-content-container__description-img"
            class="error-icon"
            title="System Error"
            alt="{{ (bundle | async)['error.technical.difficulties.subheader'] }}"
            src="assets/icons/system-error-{{ brandName }}.svg"
          />
        }
			</rcl-system-error-description>
		</rcl-system-error>
		<rcl-button-group id="error-page__main-content-container__button-group">
      @if (bundle) {
        <input
          id="error-page__main-content-container__button-group-go-dashboard"
          type="button"
          (click)="goToDashboard()"
          [value]="(bundle | async)['error.technical.difficulties.button.dashboard']"
          class="rcl-button-secondary"
        />
      }
		</rcl-button-group>
	</ng-container>
</rcl-main-content>
